module.exports = __webpack_public_path__ + "img/avp_bck_alt_phablet@2x.8f29e17.webp";